(function(){
  var map={'Scania|Serie 4':'/collections/scania-serie-4','Scania|Serie 5':'/collections/scania-serie-5','Scania|Serie 6 NTG':'/collections/scania-serie-6-ntg','Volvo|FH':'/collections/volvo-fh-fm','Volvo|FM':'/collections/volvo-fh-fm','Volkswagen|Constellation':'/collections/constellation-delivery','Volkswagen|Delivery':'/collections/constellation-delivery'};
  document.addEventListener('submit',function(e){
    var f=e.target.closest&&e.target.closest('[data-model-finder]'); if(!f) return;
    var b=f.querySelector('[data-finder-brand]').value, m=f.querySelector('[data-finder-model]').value, url=map[b+'|'+m];
    if(b&&url){
      e.preventDefault(); e.stopImmediatePropagation();
      window.dataLayer=window.dataLayer||[]; window.dataLayer.push({event:'impactrucks_model_search',brand:b,model:m});
      window.location.href=url;
    }
  },true);
})();